import React, { Component } from 'react';
import './ProgressBar.css';
import Utils from '../../../base/Utils';
import Title from './../../components/title/Title';

class ProgressBar extends Component {
    availableSizes = ['Big', 'Medium', 'Small'];
    availableTypes = ['Auto', 'Normal', 'Good', 'Middle', 'Bad'];
    
    limit = 100;
    value = 0;
    
    render() {
        this.limit = this.props.limit;
        this.value = this.props.value;
        
        var type = Utils.checkAvailability(this.availableTypes, this.props.type, true);
        var size = Utils.checkAvailability(this.availableSizes, this.props.size, true);
        
        var showHeader = this.props.showHeader;
        
        var titleSize = this.getTitleSize(size);
        
        var classValue = "ProgressBar " + size + " ";
        
        if(type !== 'Auto') 
        classValue += type;
        else
        classValue += this.getAutoClass();
        
        var percentage = this.getPercentage();
        
        return <div className={classValue}>
        {(showHeader) ? <div className="ProgressBarTitle">
        <div className="Left"><Title text={percentage + '%'} size={titleSize} /></div>
        <div className="Right"><Title text={Utils.divideByThousands(this.value) + ' / ' + Utils.divideByThousands(this.limit)} size={titleSize} /></div>
        </div> : ""}
        <div className="ProgressBarDisplay">
        <div className="ProgressBarDisplayPercentage" style={{width: percentage + '%'}}></div>
        </div>
        </div>;
    }
    
    getTitleSize(size) {
        var sizes = this.availableSizes;
        var index = sizes.indexOf(size);
        var length = (sizes.length - 1);
        
        if(index === length) 
        return sizes[length];
        else
        return sizes[(index + 1)];
    }
    
    getPercentage() {
        return Math.round((this.value * 100) / this.limit);
    }
    
    getAutoClass() {
        var percentage = this.getPercentage();
        var classValue = 'Good';
        
        if(percentage > 50) classValue = 'Middle';
        if(percentage > 90) classValue = 'Bad';
        
        return classValue;
    }
}

export default ProgressBar;
